"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var PropTypes = require("prop-types");
var React = require("react");
var react_1 = require("react");
var util_1 = require("./util");
function isFunction(v) {
    return typeof v === 'function';
}
function defaultToNull(v) {
    return v === void 0 ? null : v;
}
function toElement(c, data) {
    if (data === void 0) { data = void 0; }
    return defaultToNull(isFunction(c) ? c(data) : c);
}
function toBoolean(v) {
    return Boolean(isFunction(v) ? v() : v);
}
function shallowDifferent(prev, next) {
    var different;
    if (isArray(next) && isArray(prev)) {
        different = next.reduce(function (shd, a, idx) {
            return shd || !util_1.shallowEqual(a, prev[idx]);
        }, false);
    }
    else {
        different = !util_1.shallowEqual(prev, next);
    }
    return different;
}
function prependArg(fn, arg) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return fn.apply(void 0, [arg].concat(args));
    };
}
var isArray = Array.isArray;
/**
 * Conditionally render components based on the truthy-ness of evaluating the `test` prop.
 * Render `then` if `test` evaluates to truthy, render `else` otherwise.
 */
function If(_a) {
    var test = _a.test, then = _a.then, _else = _a["else"];
    return toElement(test ? then : _else);
}
exports.If = If;
If.propTypes = {
    test: PropTypes.any,
    then: PropTypes.any.isRequired,
    else: PropTypes.any
};
/**
 * Render the first `When` child whose`test` prop evaluates to true.
 */
function Switch(_a) {
    var children = _a.children;
    var choice;
    React.Children.forEach(children, function (child) {
        if (choice === void 0 &&
            React.isValidElement(child) &&
            child.type.isWhen &&
            toBoolean(child.props.test)) {
            choice = child;
        }
    });
    return toElement(choice ? choice.props.render : null);
}
exports.Switch = Switch;
function When(_) {
    return null;
}
exports.When = When;
When.isWhen = true;
When.propTypes = {
    test: PropTypes.any,
    render: PropTypes.any.isRequired
};
/**
 * Render the result of dispatching to the `map` method of `target`
 * passing the `with` function as the first argument.
 */
function Map(_a) {
    var target = _a.target, _with = _a["with"];
    return react_1.createElement(React.Fragment, null, target.map(_with));
}
exports.Map = Map;
Map.propTypes = {
    target: PropTypes.any.isRequired,
    with: PropTypes.func.isRequired
};
/**
 * A component that its `constructor`, `shouldComponentUpdate`, and lifecycle methods
 * can be assigned via props
 */
var Bare = /** @class */ (function (_super) {
    __extends(Bare, _super);
    function Bare(props, ctx) {
        var _this = _super.call(this, props, ctx) || this;
        _this.previousPuritySource = null;
        var constructor = props.constructor, pureBy = props.pureBy, didCatch = props.didCatch, didMount = props.didMount, didUpdate = props.didUpdate, shouldUpdate = props.shouldUpdate, willUnmount = props.willUnmount;
        if (isFunction(constructor)) {
            constructor(_this, props, ctx);
        }
        if (isFunction(didCatch)) {
            _this.componentDidCatch = prependArg(didCatch, _this);
        }
        if (isFunction(didMount)) {
            _this.componentDidMount = prependArg(didMount, _this);
        }
        if (isFunction(didUpdate)) {
            _this.componentDidUpdate = prependArg(didUpdate, _this);
        }
        if (pureBy !== void 0) {
            if (shouldUpdate !== void 0) {
                throw new Error('You can only use either `shouldUpdate`, or `pureBy` prop in Bare components');
            }
            _this.previousPuritySource = pureBy;
            _this.shouldComponentUpdate = function shouldComponentUpdate(nextProps, _) {
                var nextPuritySource = nextProps.pureBy;
                var previousPuritySource = this.previousPuritySource;
                var should = shallowDifferent(nextPuritySource, previousPuritySource);
                if (should) {
                    this.previousPuritySource = nextPuritySource;
                }
                return should;
            };
        }
        else if (isFunction(shouldUpdate)) {
            _this.shouldComponentUpdate = prependArg(shouldUpdate, _this);
        }
        if (isFunction(willUnmount)) {
            _this.componentWillUnmount = prependArg(willUnmount, _this);
        }
        return _this;
    }
    Bare.prototype.render = function () {
        return toElement(this.props.render, this);
    };
    return Bare;
}(React.Component));
exports.Bare = Bare;
Bare.propTypes = {
    render: PropTypes.any.isRequired,
    constructor: PropTypes.func,
    pureBy: PropTypes.any,
    didCatch: PropTypes.func,
    didMount: PropTypes.func,
    didUpdate: PropTypes.func,
    shouldUpdate: PropTypes.func,
    willUnmount: PropTypes.func
};
//# sourceMappingURL=index.js.map